import Link from '@atoms/Link';

export const detailedBlogBreadcrumbs = (blogName) => [
    { title: 'Home', url: '/' },
    {
        title: 'Blogs',
        url: '/blogs',
    },
    { title: blogName, active: true },
];

export const blogBreadcrumbs = () => [
    { title: 'Home', url: '/' },
    {
        title: 'Blogs',
        active: true,
    },
];

export const getBreadCrumbs = (breadcrumbElements) => {
    return breadcrumbElements.map((breadcrumb, index) => (
        <Link
            key={index}
            label={breadcrumb.title}
            href={`${breadcrumb.active ? '#' : breadcrumb.url}`}
            active={breadcrumb.active}
        ></Link>
    ));
};
